import {IDeferred, IHttpPromise, IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {DirectMailerLogDTO} from "../model/DirectMailerLogDTO";
import {Page} from "../../utils/models/Page";
import {DirectMailerLogFilterUi} from "../../opportunities_filter/model/OpportunityFilterUi";

export class DirectMailerLogsService {

    public static instance = ['$http', DirectMailerLogsService];

    public $http: IHttpService;

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    getAllDirectMailerLogs = (page: number, pageSize: number, filter: DirectMailerLogFilterUi, canceler: IDeferred<any>): IHttpPromise<Page<DirectMailerLogDTO>> => {

        return this.$http({
            method: 'POST',
            data: filter,
            url: getAbsoluteUrl('api/direct_mailer'),
            params: {page: page, pageSize: pageSize},
            timeout: canceler.promise
        })
    };
    resend = (opportunityId): IHttpPromise<DirectMailerLogDTO> => {

        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/direct_mailer/resend/' + opportunityId),
        })
    };

}